/* ============
 * User Transformer
 * ============
 *
 * The transformer for the User.
 */

import Transformer from './transformer'

const fullName = ({
  name, first_name: firstName, last_name: lastName, mothers_last_name: mothersLastName
}) => `${name || firstName || ''} ${lastName || ''} ${mothersLastName || ''}`

export {
  fullName
}

export default class JBUserTransformer extends Transformer {
  /**
   * Method used to transform a fetched user
   *
   * @param user The fetched user
   *
   * @returns {Object} The transformed user
   */
  static fetch(user) {
    return {
      id: user.id,
      name: fullName(user.user)
    }
  }

  /**
   * Method used to transform a send user
   *
   * @param user The user to be send
   *
   * @returns {Object} The transformed user
   */
  static send(user) {
    return {
      email: user.email,
      first_name: user.firstName,
      last_name: user.lastName,
      password: user.password,
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/jbUser.js